import { useModals } from 'almanac-ui/Modal'
import { Modal } from 'almanac-ui/Modal'

interface Props {
  handleSettingsChange: () => void
}

export const ConfirmModal = ({ handleSettingsChange }: Props) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root size="sm">
      <Modal.Header title="Confirm setting change" />
      <Modal.Content>
        Disabling public link sharing will remove public links for all existing files and folders in this workspace.
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="md" variant="tertiary" onPress={closeModal}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton
            size="md"
            onPress={() => {
              handleSettingsChange()
              closeModal()
            }}
          >
            Confirm
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
